module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-ricerca-particella",
      "title": "Ricerca Particella Catastale"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3487d231!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/RicercaParticellaCatastale.vue
// module id = 843
// module chunks = 39